import angular from "angular";
import { machineManufacturerLookupConfig } from "./machineManufacturer";

import { moduleName as recordsModuleName } from "../../../../records";
import { machineCabinetTypeLookupConfig } from "./cabinetType";
import { machineStyleLookupConfig } from "./styles";
import { machineContractTypeLookupConfig } from "./contractType";
import { machineDenominationLookupConfig } from "./denomination";
import { machineBillValidatorLookupConfig } from "./billValidator";
import { machinePrinterLookupConfig } from "./printer";
import { machineConversionTypeLookupConfig } from "./conversionType"

export const vsModuleName = "SlotTrak.Machines.Config.Lookups";

angular
  .module(vsModuleName, [recordsModuleName])
  .config(machineManufacturerLookupConfig)
  .config(machineCabinetTypeLookupConfig)
  .config(machineStyleLookupConfig)
  .config(machineDenominationLookupConfig)
  .config(machineContractTypeLookupConfig)
  .config(machineBillValidatorLookupConfig)
  .config(machinePrinterLookupConfig)
  .config(machineConversionTypeLookupConfig);
